(function () {

  function initProductFaq(faqContainer) {

    if (!faqContainer) return;

    if (faqContainer.dataset.faqInitialized === 'true') {
      return;
    }

    faqContainer.dataset.faqInitialized = 'true';

    const items = faqContainer.querySelectorAll('[data-faq-item]');

    items.forEach((item) => {

      const button = item.querySelector('[data-faq-toggle]');
      const answer = item.querySelector('[data-faq-answer]');

      if (!button || !answer) return;

      /*
       * Remove Liquid's hidden attribute.
       * CSS/JS will control visibility.
       */
      answer.removeAttribute('hidden');

      answer.style.height = '0px';

      button.addEventListener('click', function () {

        const isOpen = item.classList.contains('is-open');

        /*
         * Close other FAQs
         */
        items.forEach((otherItem) => {

          if (otherItem === item) return;

          const otherButton =
            otherItem.querySelector('[data-faq-toggle]');

          const otherAnswer =
            otherItem.querySelector('[data-faq-answer]');

          if (!otherButton || !otherAnswer) return;

          if (otherItem.classList.contains('is-open')) {

            otherAnswer.style.height =
              otherAnswer.scrollHeight + 'px';

            /*
             * Force browser to register current height
             */
            otherAnswer.offsetHeight;

            otherAnswer.style.height = '0px';

            otherItem.classList.remove('is-open');

            otherButton.setAttribute(
              'aria-expanded',
              'false'
            );
          }
        });


        /*
         * Close current FAQ
         */
        if (isOpen) {

          answer.style.height =
            answer.scrollHeight + 'px';

          answer.offsetHeight;

          answer.style.height = '0px';

          item.classList.remove('is-open');

          button.setAttribute(
            'aria-expanded',
            'false'
          );

          return;
        }


        /*
         * Open current FAQ
         */
        item.classList.add('is-open');

        button.setAttribute(
          'aria-expanded',
          'true'
        );

        answer.style.height =
          answer.scrollHeight + 'px';


        /*
         * Once animation finishes,
         * use auto height so rich text remains responsive.
         */
        answer.addEventListener(
          'transitionend',
          function handleOpenTransition(event) {

            if (event.propertyName !== 'height') return;

            if (item.classList.contains('is-open')) {
              answer.style.height = 'auto';
            }

            answer.removeEventListener(
              'transitionend',
              handleOpenTransition
            );
          }
        );

      });

    });

  }


  function initAllProductFaqs() {

    const faqContainers =
      document.querySelectorAll('[data-product-faq]');

    faqContainers.forEach(function (faqContainer) {
      initProductFaq(faqContainer);
    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAllProductFaqs
    );

  } else {

    initAllProductFaqs();

  }

})();